import React from "react";

import "./StandardButton.css";

export const StandardButton = ({text, onClick, disabled, required}) => {

    const handleClick = () => {
        onClick();
    }

    return (
        <button disabled={disabled} className={(required)?"standard-button-observation-pdsa": "standard-button"} onClick={handleClick}>{text}</button>
    );
}
